// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"e9f99738","78":"1e867bb7","110":"b4a466ca","416":"97d349f8","489":"f5a32f7e","538":"7502cfce","566":"bd2dcd29","614":"084c75c7","676":"d8b91a22"}[chunkId] + ".chunk.js";
};